(() => {
  // Some Shopify default/legacy password page content can include a `jumbo-text`
  // custom element and load `jumbo-text.js` as a module.
  //
  // In some themes (e.g. Horizon), the upstream `jumbo-text.js` references
  // internal bare ESM specifiers like `@theme/utilities`, which browsers cannot
  // resolve without a bundler/import map. That produces a console error on the
  // password page.
  //
  // This lightweight implementation prevents the runtime error and keeps the
  // element functional without any dependencies.

  if (typeof window === "undefined") return;
  if (!window.customElements) return;
  if (window.customElements.get("jumbo-text")) return;

  class JumboText extends HTMLElement {
    connectedCallback() {
      // No-op: the server-rendered markup already contains line spans.
    }
  }

  window.customElements.define("jumbo-text", JumboText);
})();

